import { Route, Routes } from "react-router-dom";
import Userlayout from "../layout/Userlayout";
import NotFoundPage from "../pages/NotFoundPage";
import ModuleListPage from "../pages/ModuleListPage";
import { PrivateRoute } from "./PrivateRoutes";
import NotificationsPage from "../layout/NotificationsPage";

function UsersRoutes() {
    return ( 
        <>
    <Userlayout>
        <Routes>
       <Route  path='/module-list' element={
                <PrivateRoute>
                <ModuleListPage />
                </PrivateRoute>}>
          </Route>
       <Route  path='/notifications' element={
                <PrivateRoute>
                <NotificationsPage />
                </PrivateRoute>}>
          </Route>
         
        <Route path="/*" element={<NotFoundPage />}></Route>
        </Routes>
        </Userlayout>

        </>
     );
}

export default UsersRoutes;